import { MapTo } from '@adobe/aem-react-editable-components';
import OneTimePasscode, { OneTimePasscodeEditConfig } from './OneTimePasscode';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/one-time-passcode',
)(OneTimePasscode, OneTimePasscodeEditConfig);